import { render, staticRenderFns } from "./addHealplan.vue?vue&type=template&id=5188be83&scoped=true&"
import script from "./addHealplan.vue?vue&type=script&lang=js&"
export * from "./addHealplan.vue?vue&type=script&lang=js&"
import style0 from "./addHealplan.vue?vue&type=style&index=0&id=5188be83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188be83",
  null
  
)

export default component.exports